import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import HeroComponent from './js/hero.component';

ComponentsFactory.getInstance().define('hero', HeroComponent);
